// extracted by mini-css-extract-plugin
export default {"trashCan":"styles_trashCan__xIXJF","textContent":"styles_textContent__NcP8S","btnCancel":"styles_btnCancel__+Ije1"};